<template>
  <div class="teaching-support-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>教学支持</span>
          <strong></strong>
        </dt>
        <dd class="choose-answer show-flex-box-c">
          <strong>线上教学平台，海量资源共享，提供包括课件、讲义、说课视频、实录视频、制作视频在内的一站式解决方案。</strong>
        </dd>
        <dd class="choose-pic-box show-flex-box-r">
          <dl class="show-flex-box-c">
            <dt class="show-flex-box-r">
              <span>
                <img src="../../assets/home/course_support_1.png" alt="德阳经开科创" draggable="false">
              </span>
              <strong>
                <img src="../../assets/home/course_support_2.png" alt="德阳经开科创" draggable="false">
              </strong>
            </dt>
            <dd class="show-flex-box-r">
              <span>
                <img src="../../assets/home/course_support_3.png" alt="德阳经开科创" draggable="false">
              </span>
              <strong>
                <img src="../../assets/home/course_support_4.png" alt="德阳经开科创" draggable="false">
              </strong>
            </dd>
          </dl>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'teaching_support_cpn',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .teaching-support-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .teaching-support-box{
    width: 100%;
    background: #fff;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .teaching-support-font-style( 40px; bold; auto; #191D21 );
            padding-top: 85px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 38px;
          }
        }
        &>.choose-answer{
          align-items: center;
          padding-bottom: 58px;
          &>strong{
            .teaching-support-font-style( 18px; 400; 34px; #3E3A39 );
          }
        }
        &>.choose-pic-box{
          width: 100%;
          padding-bottom: 80px;
          justify-content: center;
          &>dl{
            width: 100%;
            &>dt{
              width: 100%;
              justify-content: space-between;
              align-items: center;
              padding-bottom: 20px;
              &>span{
                width: 590px;
                &>img{
                  width: 100%;
                }               
              }
              &>strong{
                width: 590px;
                &>img{
                  width: 100%;
                }               
              }
            }
            &>dd{
              width: 100%;
              justify-content: space-between;
              align-items: center;
              &>span{
                width: 590px;
                &>img{
                  width: 100%;
                }               
              }
              &>strong{
                width: 590px;
                &>img{
                  width: 100%;
                }               
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/teaching_support_cpn.vue